interface PlanDuration {
  durationDays: number;
  durationMonths: number;
  durationYears: number;
}

// Describes how often a recurring plan renews, e.g. 'month', 'quarter', 'year', '2 months'
export const billingPeriod = (plan: PlanDuration) => {
  const parts = [
    { count: plan.durationYears, unit: 'year' },
    { count: plan.durationMonths, unit: 'month' },
    { count: plan.durationDays, unit: 'day' }
  ].filter((part) => part.count > 0);

  if (parts.length === 1) {
    const { count, unit } = parts[0];

    if (count === 1) return unit;
    if (unit === 'month' && count === 3) return 'quarter';
    if (unit === 'month' && count === 12) return 'year';
    if (unit === 'day' && count === 7) return 'week';
  }

  return parts.map((part) => `${part.count} ${part.unit}s`).join(' and ');
};
